import React from "react";

const dummyQuality = [
  { product: "Industrial Pump", status: "OK" },
  { product: "Gear Assembly", status: "Check Required" },
  { product: "Hydraulic Cylinder", status: "OK" },
];

export default function SyntraMfgQualityPage({ onClose }) {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-700">Risk, Quality & Traceability (Dummy Data)</h3>
      <ul className="space-y-2">
        {dummyQuality.map((q, idx) => (
          <li key={idx} className="border p-3 rounded-lg bg-gray-50">
            <span className="font-semibold">{q.product}</span> — Status: {q.status}
          </li>
        ))}
      </ul>
    </div>
  );
}
